module.exports = __webpack_public_path__ + "static/img/组 9.5dcce8b2.png";